import request from "@/utils/request";

export default function getMonthlyByDeviceId(deviceId) {
    return request({
        url: `/device/monthly/getMonthlyByDeviceId/${deviceId}`,
    })
}
